export default "__VITE_ASSET__C8sSIfxe__"